import React from 'react';

function jaccardGda() {
  return (
    <math display="block">
      <mrow>
        <msub>
          <mi mathvariant="italic">Jaccard</mi>
          <mrow>
            <mspace width="0.167em" />
            <mi>G</mi>
          </mrow>
        </msub>
        <mo>=</mo>
        <mfrac>
          <mrow>
            <msub>
              <mi>G</mi>
              <mn>1</mn>
            </msub>
            <mo>∩</mo>
            <msub>
              <mi>G</mi>
              <mn>2</mn>
            </msub>
          </mrow>
          <mrow>
            <mi>G</mi>
            <mn>1</mn>
            <mo>∪</mo>
            <mi>G</mi>
            <mn>2</mn>
          </mrow>
        </mfrac>
      </mrow>
    </math>
  );
}

function jaccardVda() {
  return (
    <math display="block">
      <mrow>
        <msub>
          <mi mathvariant="italic">Jaccard</mi>
          <mrow>
            <mspace width="0.167em" />
            <mi>V</mi>
          </mrow>
        </msub>
        <mo>=</mo>
        <mfrac>
          <mrow>
            <msub>
              <mi>V</mi>
              <mn>1</mn>
            </msub>
            <mo>∩</mo>
            <msub>
              <mi>V</mi>
              <mn>2</mn>
            </msub>
          </mrow>
          <mrow>
            <mi>V</mi>
            <mn>1</mn>
            <mo>∪</mo>
            <mi>V</mi>
            <mn>2</mn>
          </mrow>
        </mfrac>
      </mrow>
    </math>
  );
}

function gdaScore() {
  return (
    <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
      <mrow>
        <msub>
          <mi>S</mi>
          <mrow>
            <mi mathvariant="italic">GDA</mi>
          </mrow>
        </msub>
        <mo>=</mo>
        <msub>
          <mi>W</mi>
          <mrow>
            <mi mathvariant="italic">C</mi>
          </mrow>
        </msub>
        <mo>+</mo>
        <msub>
          <mi>W</mi>
          <mrow>
            <mi mathvariant="italic">T</mi>
          </mrow>
        </msub>
        <mo>+</mo>
        <msub>
          <mi>W</mi>
          <mrow>
            <mi mathvariant="italic">I</mi>
          </mrow>
        </msub>
        <mo>+</mo>
        <msub>
          <mi>W</mi>
          <mrow>
            <mi mathvariant="italic">M</mi>
          </mrow>
        </msub>
        <mo>+</mo>
        <msub>
          <mi>W</mi>
          <mrow>
            <mi mathvariant="italic">L</mi>
          </mrow>
        </msub>
      </mrow>
    </math>
  );
}

function gdaScoreCurated() {
  return (
    <>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mtext>The set C of CURATED sources is defined as:</mtext>
        </mrow>
      </math>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mi>C</mi>
          <mo>=</mo>
          <mo stretchy="true" form="prefix">
            &#123;
          </mo>
          <mrow>
            <mi>CLINGEN</mi>
            <mo>,</mo>
            <mi>CLINVAR</mi>
            <mo>,</mo>
            <mi>GENCC</mi>
            <mo>,</mo>
            <mi>MGD</mi>
            <mo>,</mo>
            <mi>HUMAN</mi>
            <mo>,</mo>
            <mi>RGD</mi>
            <mo>,</mo>
            <mi>HUMAN</mi>
            <mo>,</mo>
            <mi>ORPHANET</mi>
            <mo>,</mo>
            <mi>PSYGENET</mi>
            <mo>,</mo>
            <mi>UNIPROT</mi>
          </mrow>
          <mo stretchy="true" form="postfix">
            &#125;
          </mo>
        </mrow>
      </math>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow className="pl-4">
          {' '}
          <mtext>given a subset</mtext> <mspace width="0.222em" />
          <msub>
            <mi>S</mi>
            <mrow>
              <mi mathvariant="italic">C</mi>
            </mrow>
          </msub>
          <mo>,</mo>
          <mspace width="0.222em" />
          <msub>
            <mi>S</mi>
            <mrow>
              <mi mathvariant="italic">C</mi>
            </mrow>
          </msub>
          <mspace width="0.222em" />
          <mo>&#x2286;</mo>
          <mspace width="0.222em" />
          <mo>C,</mo>
          <mspace width="0.222em" />
          <msub>
            <mi>W</mi>
            <mrow>
              <mi mathvariant="italic">C</mi>
            </mrow>
          </msub>
          <mspace width="0.222em" />
          <mtext>is defined as:</mtext>
        </mrow>
      </math>
      <br></br>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        {' '}
        <mrow>
          <msub>
            <mi>W</mi>
            <mrow>
              <mi mathvariant="italic">C</mi>
            </mrow>
          </msub>
          <mo>=</mo>
          <mrow>
            <mo stretchy="true" form="prefix">
              &#123;
            </mo>
            <mtable>
              <mtr>
                <mtd>
                  <mn>0.7</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">C</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>&gt;</mo>
                  <mn>4</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>

              <mtr>
                <mtd>
                  <mn>0.6</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">C</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>=</mo>
                  <mn>4</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0.5</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">C</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>=</mo>
                  <mn>3</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0.45</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">C</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>=</mo>
                  <mn>2</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0.4</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">C</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>=</mo>
                  <mn>1</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">C</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>=</mo>
                  <mn>0</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
            </mtable>
          </mrow>
        </mrow>
      </math>
    </>
  );
}

function gdaScoreClinicalTrials() {
  return (
    <>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mtext>The set T of CLINICALTRIALS sources is defined as:</mtext>
        </mrow>
      </math>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mi>T</mi>
          <mo>=</mo>
          <mo stretchy="true" form="prefix">
            &#123;
          </mo>
          <mrow>
            <mi>CLINICALTRIALS</mi>
          </mrow>
          <mo stretchy="true" form="postfix">
            &#125;
          </mo>
        </mrow>
      </math>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML" className="pl-4">
        <mrow>
          <mtext>given a subset</mtext>
          <mspace width="0.222em" />
          <msub>
            <mi>S</mi>
            <mrow>
              <mi mathvariant="italic">T</mi>
            </mrow>
          </msub>
          <mo>,</mo>
          <mspace width="0.222em" />
          <msub>
            <mi>S</mi>
            <mrow>
              <mi mathvariant="italic">T</mi>
            </mrow>
          </msub>
          <mspace width="0.222em" />
          <mo>&#x2286;</mo>
          <mspace width="0.222em" />
          <mo>T,</mo>
          <mspace width="0.222em" />
          <msub>
            <mi>W</mi>
            <mrow>
              <mi mathvariant="italic">T</mi>
            </mrow>
          </msub>
          <mspace width="0.222em" />
          <mtext>is defined as:</mtext>
        </mrow>
      </math>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <msub>
            <mi>W</mi>
            <mrow>
              <mi mathvariant="italic">T</mi>
            </mrow>
          </msub>
          <mo>=</mo>
          <mrow>
            <mo stretchy="true" form="prefix">
              &#123;
            </mo>
            <mtable>
              <mtr>
                <mtd>
                  <mn>0.1</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">T</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>&gt;</mo>
                  <mn>0</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">T</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>=</mo>
                  <mn>0</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
            </mtable>
          </mrow>
        </mrow>
      </math>
    </>
  );
}

function gdaScoreInferred() {
  return (
    <>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mtext>The set I of INFERRED sources is defined as:</mtext>
        </mrow>
      </math>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mi>I</mi>
          <mo>=</mo>
          <mo stretchy="true" form="prefix">
            &#123;
          </mo>
          <mrow>
            <mi>FINNGEN</mi>
            <mo>,</mo>
            <mi>GWASCAT</mi>
            <mo>,</mo>
            <mi>HPO</mi>
            <mo>,</mo>
            <mi>PHEWASCAT</mi>
            <mo>,</mo>
            <mi>UKBIOBANK</mi>
          </mrow>
          <mo stretchy="true" form="postfix">
            &#125;
          </mo>
        </mrow>
      </math>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML" className="pl-4">
        <mrow>
          <mtext>given a subset</mtext>
          <mspace width="0.222em" />
          <msub>
            <mi>S</mi>
            <mrow>
              <mi mathvariant="italic">I</mi>
            </mrow>
          </msub>
          <mo>,</mo>
          <mspace width="0.222em" />
          <msub>
            <mi>S</mi>
            <mrow>
              <mi mathvariant="italic">I</mi>
            </mrow>
          </msub>
          <mspace width="0.222em" />
          <mo>&#x2286;</mo>
          <mspace width="0.222em" />
          <mo>I,</mo>
          <mspace width="0.222em" />
          <msub>
            <mi>W</mi>
            <mrow>
              <mi mathvariant="italic">I</mi>
            </mrow>
          </msub>
          <mspace width="0.222em" />
          <mtext>is defined as:</mtext>
        </mrow>
      </math>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <msub>
            <mi>W</mi>
            <mrow>
              <mi mathvariant="italic">I</mi>
            </mrow>
          </msub>
          <mo>=</mo>
          <mrow>
            <mo stretchy="true" form="prefix">
              &#123;
            </mo>
            <mtable>
              <mtr>
                <mtd>
                  <mn>0.25</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">I</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>&gt;=</mo>
                  <mn>3</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0.15</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">I</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>=</mo>
                  <mn>2</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0.05</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">I</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>=</mo>
                  <mn>1</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">I</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>=</mo>
                  <mn>0</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
            </mtable>
          </mrow>
        </mrow>
      </math>
    </>
  );
}

function gdaScoreModels() {
  return (
    <>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mtext>The set M of MODELS sources is defined as:</mtext>
        </mrow>
      </math>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mi>M</mi>
          <mo>=</mo>
          <mo stretchy="true" form="prefix">
            &#123;
          </mo>
          <mrow>
            <mi>MGD MOUSE</mi>
            <mo>,</mo>
            <mi>RGD RAT</mi>
            <mo>,</mo>
            <mi>TEXTMINING MODELS</mi>
          </mrow>
          <mo stretchy="true" form="postfix">
            &#125;
          </mo>
        </mrow>
      </math>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML" className="pl-4">
        <mrow>
          <mtext>given a subset</mtext>
          <mspace width="0.222em" />
          <msub>
            <mi>S</mi>
            <mrow>
              <mi mathvariant="italic">M</mi>
            </mrow>
          </msub>
          <mo>,</mo>
          <mspace width="0.222em" />
          <msub>
            <mi>S</mi>
            <mrow>
              <mi mathvariant="italic">M</mi>
            </mrow>
          </msub>
          <mspace width="0.222em" />
          <mo>&#x2286;</mo>
          <mspace width="0.222em" />
          <mo>M,</mo>
          <mspace width="0.222em" />
          <msub>
            <mi>W</mi>
            <mrow>
              <mi mathvariant="italic">M</mi>
            </mrow>
          </msub>
          <mspace width="0.222em" />
          <mtext>is defined as:</mtext>
        </mrow>
      </math>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <msub>
            <mi>W</mi>
            <mrow>
              <mi mathvariant="italic">M</mi>
            </mrow>
          </msub>
          <mo>=</mo>
          <mrow>
            <mo stretchy="true" form="prefix">
              &#123;
            </mo>
            <mtable>
              <mtr>
                <mtd>
                  <mn>0.1</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">M</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>&gt;</mo>
                  <mn>1</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0.05</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">M</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>=</mo>
                  <mn>1</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">M</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>=</mo>
                  <mn>0</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
            </mtable>
          </mrow>
        </mrow>
      </math>
    </>
  );
}

function gdaScoreLiterature() {
  return (
    <>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mtext>The set L of LITERATURE sources is defined as:</mtext>
        </mrow>
      </math>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mi>L</mi>
          <mo>=</mo>
          <mo stretchy="true" form="prefix">
            &#123;
          </mo>
          <mrow>
            <mi>TEXTMINING HUMAN</mi>
            <mo>,</mo>
            <mi>TEXTMINING MODELS</mi>
          </mrow>
          <mo stretchy="true" form="postfix">
            &#125;
          </mo>
        </mrow>
      </math>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML" className="pl-4">
        <mrow>
          <msub>
            <mi>N</mi>
            <mrow>
              <mi mathvariant="italic">Pubs</mi>
            </mrow>
          </msub>
          <mspace width="0.222em" />
          <mtext>is the number of publications supporting a GDA from L.</mtext>
        </mrow>
      </math>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <msub>
            <mi>W</mi>
            <mrow>
              <mi mathvariant="italic">L</mi>
            </mrow>
          </msub>
          <mo>=</mo>
          <mrow>
            <mo stretchy="true" form="prefix">
              &#123;
            </mo>
            <mtable>
              <mtr>
                <mtd>
                  <mn>0.4</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>N</mi>
                    <mrow>
                      <mi mathvariant="italic">Pubs</mi>
                    </mrow>
                  </msub>
                  <mo>&gt;</mo>
                  <mn>99</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0.3</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <mn>9</mn>
                  <mo>&lt;</mo>
                  <msub>
                    <mi>N</mi>
                    <mrow>
                      <mi mathvariant="italic">Pubs</mi>
                    </mrow>
                  </msub>
                  <mo>=&lt;</mo>
                  <mn>99</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0.2</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <mn>1</mn>
                  <mo>&lt;</mo>
                  <msub>
                    <mi>N</mi>
                    <mrow>
                      <mi mathvariant="italic">Pubs</mi>
                    </mrow>
                  </msub>
                  <mo>=&lt;</mo>
                  <mn>9</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0.1</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>N</mi>
                    <mrow>
                      <mi mathvariant="italic">Pubs</mi>
                    </mrow>
                  </msub>
                  <mo>=</mo>
                  <mn>1</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>N</mi>
                    <mrow>
                      <mi mathvariant="italic">Pubs</mi>
                    </mrow>
                  </msub>
                  <mo>=</mo>
                  <mn>0</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
            </mtable>
          </mrow>
        </mrow>
      </math>
    </>
  );
}

function DiseaseSpecificityIndex() {
  return (
    <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
      <mrow>
        <mi mathvariant="italic">DSI</mi>
        <mo>=</mo>
        <mfrac>
          <mrow>
            <msub>
              <mi mathvariant="italic">log</mi>
              <mn>2</mn>
            </msub>
            <mo stretchy="false" form="prefix">
              (
            </mo>
            <mfrac>
              <msub>
                <mi>N</mi>
                <mi>d</mi>
              </msub>
              <msub>
                <mi>N</mi>
                <mi>T</mi>
              </msub>
            </mfrac>
            <mo stretchy="false" form="postfix">
              )
            </mo>
          </mrow>
          <mrow>
            <msub>
              <mi mathvariant="italic">log</mi>
              <mn>2</mn>
            </msub>
            <mo stretchy="false" form="prefix">
              (
            </mo>
            <mfrac>
              <mn>1</mn>
              <msub>
                <mi>N</mi>
                <mi>T</mi>
              </msub>
            </mfrac>
            <mo stretchy="false" form="postfix">
              )
            </mo>
          </mrow>
        </mfrac>
      </mrow>
    </math>
  );
}

function DiseasePleiotropyIndex() {
  return (
    <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
      <mrow>
        <mi mathvariant="italic">DPI</mi>
        <mo>=</mo>
        <mo stretchy="false" form="prefix">
          (
        </mo>
        <mfrac>
          <msub>
            <mi>N</mi>
            <mrow>
              <mi mathvariant="italic">dc</mi>
            </mrow>
          </msub>
          <msub>
            <mi>N</mi>
            <mrow>
              <mi mathvariant="italic">TC</mi>
            </mrow>
          </msub>
        </mfrac>
        <mo stretchy="false" form="postfix">
          )
        </mo>
      </mrow>
    </math>
  );
}

function vdaScore() {
  return (
    <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
      <mrow>
        <msub>
          <mi>S</mi>
          <mrow>
            <mi mathvariant="italic">VDA</mi>
          </mrow>
        </msub>
        <mo>=</mo>
        <msub>
          <mi>W</mi>
          <mrow>
            <mi mathvariant="italic">C</mi>
          </mrow>
        </msub>
        <mo>+</mo>
        <msub>
          <mi>W</mi>
          <mrow>
            <mi mathvariant="italic">B</mi>
          </mrow>
        </msub>
        <mo>+</mo>
        <msub>
          <mi>W</mi>
          <mrow>
            <mi mathvariant="italic">L</mi>
          </mrow>
        </msub>
      </mrow>
    </math>
  );
}

function vdaScoreCurated() {
  return (
    <>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mtext>The set C of CURATED sources is defined as:</mtext>
        </mrow>
      </math>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mi>C</mi>
          <mo>=</mo>
          <mo stretchy="true" form="prefix">
            &#123;
          </mo>
          <mrow>
            <mi>CLINGEN</mi>
            <mo>,</mo>
            <mi>CLINVAR</mi>
            <mo>,</mo>
            <mi>GWASCAT</mi>
            <mo>,</mo>
            <mi>PHEWASCAT</mi>
            <mo>,</mo>
            <mi>UNIPROT</mi>
          </mrow>
          <mo stretchy="true" form="postfix">
            &#125;
          </mo>
        </mrow>
      </math>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow className="pl-4">
          {' '}
          <mtext>given a subset</mtext> <mspace width="0.222em" />
          <msub>
            <mi>S</mi>
            <mrow>
              <mi mathvariant="italic">C</mi>
            </mrow>
          </msub>
          <mo>,</mo>
          <mspace width="0.222em" />
          <msub>
            <mi>S</mi>
            <mrow>
              <mi mathvariant="italic">C</mi>
            </mrow>
          </msub>
          <mspace width="0.222em" />
          <mo>&#x2286;</mo>
          <mspace width="0.222em" />
          <mo>C,</mo>
          <mspace width="0.222em" />
          <msub>
            <mi>W</mi>
            <mrow>
              <mi mathvariant="italic">C</mi>
            </mrow>
          </msub>
          <mspace width="0.222em" />
          <mtext>is defined as:</mtext>
        </mrow>
      </math>
      <br></br>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        {' '}
        <mrow>
          <msub>
            <mi>W</mi>
            <mrow>
              <mi mathvariant="italic">C</mi>
            </mrow>
          </msub>
          <mo>=</mo>
          <mrow>
            <mo stretchy="true" form="prefix">
              &#123;
            </mo>
            <mtable>
              <mtr>
                <mtd>
                  <mn>0.7</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">C</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>&gt;</mo>
                  <mn>2</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>

              <mtr>
                <mtd>
                  <mn>0.6</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">C</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>=</mo>
                  <mn>2</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0.4</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">C</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>=</mo>
                  <mn>1</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">C</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>=</mo>
                  <mn>0</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
            </mtable>
          </mrow>
        </mrow>
      </math>
    </>
  );
}

function vdaScoreLiterature() {
  return (
    <>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mtext>The set L of LITERATURE sources is defined as:</mtext>
        </mrow>
      </math>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mi>L</mi>
          <mo>=</mo>
          <mo stretchy="true" form="prefix">
            &#123;
          </mo>
          <mrow>
            <mi>TEXTMINING HUMAN</mi>
          </mrow>
          <mo stretchy="true" form="postfix">
            &#125;
          </mo>
        </mrow>
      </math>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML" className="pl-4">
        <mrow>
          <msub>
            <mi>N</mi>
            <mrow>
              <mi mathvariant="italic">Pubs</mi>
            </mrow>
          </msub>
          <mspace width="0.222em" />
          <mtext>is the number of publications supporting a VDA from L.</mtext>
        </mrow>
      </math>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <msub>
            <mi>W</mi>
            <mrow>
              <mi mathvariant="italic">L</mi>
            </mrow>
          </msub>
          <mo>=</mo>
          <mrow>
            <mo stretchy="true" form="prefix">
              &#123;
            </mo>
            <mtable>
              <mtr>
                <mtd>
                  <mn>0.3</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>N</mi>
                    <mrow>
                      <mi mathvariant="italic">Pubs</mi>
                    </mrow>
                  </msub>
                  <mo>&gt;</mo>
                  <mn>9</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0.2</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <mn>1</mn>
                  <mo>&lt;</mo>
                  <msub>
                    <mi>N</mi>
                    <mrow>
                      <mi mathvariant="italic">Pubs</mi>
                    </mrow>
                  </msub>
                  <mo>=&lt;</mo>
                  <mn>9</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0.1</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>N</mi>
                    <mrow>
                      <mi mathvariant="italic">Pubs</mi>
                    </mrow>
                  </msub>
                  <mo>=</mo>
                  <mn>1</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>N</mi>
                    <mrow>
                      <mi mathvariant="italic">Pubs</mi>
                    </mrow>
                  </msub>
                  <mo>=</mo>
                  <mn>0</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
            </mtable>
          </mrow>
        </mrow>
      </math>
    </>
  );
}

function vdaScoreBiobank() {
  return (
    <>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mtext>The set B of BIOBANK sources is defined as:</mtext>
        </mrow>
      </math>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <mi>B</mi>
          <mo>=</mo>
          <mo stretchy="true" form="prefix">
            &#123;
          </mo>
          <mrow>
            <mi>FINNGEN</mi>
            <mo>,</mo>
            <mi>UKBIOBANK</mi>
          </mrow>
          <mo stretchy="true" form="postfix">
            &#125;
          </mo>
        </mrow>
      </math>
      <math display="inline" xmlns="http://www.w3.org/1998/Math/MathML" className="pl-4">
        <mrow>
          <mtext>given a subset</mtext>
          <mspace width="0.222em" />
          <msub>
            <mi>S</mi>
            <mrow>
              <mi mathvariant="italic">B</mi>
            </mrow>
          </msub>
          <mo>,</mo>
          <mspace width="0.222em" />
          <msub>
            <mi>S</mi>
            <mrow>
              <mi mathvariant="italic">B</mi>
            </mrow>
          </msub>
          <mspace width="0.222em" />
          <mo>&#x2286;</mo>
          <mspace width="0.222em" />
          <mo>B,</mo>
          <mspace width="0.222em" />
          <msub>
            <mi>W</mi>
            <mrow>
              <mi mathvariant="italic">B</mi>
            </mrow>
          </msub>
          <mspace width="0.222em" />
          <mtext>is defined as:</mtext>
        </mrow>
      </math>
      <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
        <mrow>
          <msub>
            <mi>W</mi>
            <mrow>
              <mi mathvariant="italic">B</mi>
            </mrow>
          </msub>
          <mo>=</mo>
          <mrow>
            <mo stretchy="true" form="prefix">
              &#123;
            </mo>
            <mtable>
              <mtr>
                <mtd>
                  <mn>0.2</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">B</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>&gt;</mo>
                  <mn>0</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
              <mtr>
                <mtd>
                  <mn>0</mn>
                </mtd>
                <mtd>
                  <mi>if</mi>
                  <mspace width="0.222em" />
                  <msub>
                    <mi>|S</mi>
                    <mrow>
                      <mi mathvariant="italic">B</mi>
                    </mrow>
                  </msub>
                  <mi>|</mi>
                  <mo>=</mo>
                  <mn>0</mn>
                  <mspace width="0.222em" />
                </mtd>
              </mtr>
            </mtable>
          </mrow>
        </mrow>
      </math>
    </>
  );
}

function evidenceIndex() {
  return (
    <math display="block" xmlns="http://www.w3.org/1998/Math/MathML">
      <mrow>
        <mi mathvariant="italic">EI</mi>
        <mo>=</mo>
        <mfrac>
          <msub>
            <mi>N</mi>
            <msub>
              <mrow>
                <mi mathvariant="italic">pubs</mi>
              </mrow>
              <mo>+</mo>
            </msub>
          </msub>
          <msub>
            <mi>N</mi>
            <msub>
              <mrow>
                <mi mathvariant="italic">pubs</mi>
              </mrow>
              <mrow>
                <mi mathvariant="italic">total</mi>
              </mrow>
            </msub>
          </msub>
        </mfrac>
      </mrow>
    </math>
  );
}

export {
  jaccardGda,
  jaccardVda,
  gdaScore,
  gdaScoreCurated,
  gdaScoreClinicalTrials,
  gdaScoreInferred,
  gdaScoreModels,
  gdaScoreLiterature,
  DiseaseSpecificityIndex,
  DiseasePleiotropyIndex,
  vdaScore,
  vdaScoreCurated,
  vdaScoreLiterature,
  vdaScoreBiobank,
  evidenceIndex,
};
